import { usePermissions } from "./usePermissions";
import { usePlan } from "./usePlan";

export const useAuthorization = () => {
    const { can, canAny, role, loading: permissionsLoading } = usePermissions();
    const { hasFeature, planId, features, loading: planLoading } = usePlan();

    const isSuperAdmin = role === "super_admin";

    const canAccess = ({ feature, permission, permissionsAny = [] } = {}) => {
        if (isSuperAdmin) {
            return true;
        }

        if (feature && !hasFeature(feature)) {
            return false;
        }

        if (permission) {
            return can(permission);
        }
        
        if (permissionsAny.length > 0) {
            return canAny(permissionsAny);
        }

        return true;
    };

    return {
        canAccess,
        hasFeature,
        planId,
        features,
        loading: permissionsLoading || planLoading,
        isSuperAdmin,
    };
};
